export const meanUserId = "u-mean-user";
export const loadTestingUserId = "u-load-test";

type ProposalFormInfo = {
  googleFormId: string;
  spreadsheetId: string;
  spreadsheetRange: string;
};

export const proposalFormConstants: { [name: string]: ProposalFormInfo } = {
  "SFF Rolling Application (real)": {
    googleFormId: "1l_dpYL2cHuseIRbPGRDHaczH4-9avMNnKVbB3iqhWTw",
    spreadsheetId: "1cVoqqyXYDmAYorQ7SAfraEOr5FDPXMcTD2BYxP5Js5Y",
    spreadsheetRange: "Form Responses 1!A2:CY",
  },
  "SFF Rolling Application (testing)": {
    googleFormId: "12CAfbtI36s2aEonlxpVenOEEFBLITDzxKtosDEHp21Y",
    spreadsheetId: "1y17kY9UAhJlFwJxKP32fRb2gqNcfxlbT_jwxEfkRyhE",
    spreadsheetRange: "Form Responses 1!A2:DA",
  },
  "SFF Charity Funding Rolling Application": {
    googleFormId: "1hkZBYXwkAvceq3qItmqpvLv308AG2TOE7ap_mQfpChU",
    spreadsheetId: "1I1qewTUt_41EwZkoI25Ooxb6j9m1b75CTm7h-gBc8nc",
    spreadsheetRange: "Form Responses 1!A2:BZ",
  },
  "SFF for-profit non-dilutive grant application": {
    googleFormId: "1-uJawKdCxo5u7yYfg3yKbX_F7POM2uzcRmOPGeR1EU4",
    spreadsheetId: "12c_AGruVvEJ44R1VW0t0O2RDRAUPggpv6EHBpfIYmkE",
    spreadsheetRange: "Form Responses 1!A2:BO",
  },
};

export const supplementalMatchingSpreadsheet = {
  id: "1RwR7PJ6v1MXwtjg3BjhUutLZsWw_Izol451BDiXLlLs",
  range: "Form Responses 1!A:O",
};

export const speculationGrantsSpreadsheet = {
  id: "1-dWGMIdrP7H_qFs7E5JajxWEwnyquG_oRCkCNZdDoco",
  requestsRange: "Grant_Requests!A2:AV",
  grantsRange: "Grants_And_Settlements!A2:AM",
};

export const defaultExpectedMatchingFraction = 0.75;
export const defaultOutsideDollarSubstitutionRate = 0;
